export default String.raw`
{% assign product = include -%}

{% assign directAddToCart = false -%}
{% if product.Attributes == null and product.AttributesEditable == null and product.AttributesPolyvalent == null and product.HasAttributes == false -%}
    {% assign directAddToCart = true -%}
{% else -%}
    {% assign productAttributesSize = product.Attributes | Size -%}
    {% if productAttributesSize == 1 -%}
        {% if product.Attributes[0].Name contains '360photo' -%}
            {% assign directAddToCart = true -%}
        {% endif -%}
        {% assign productAttributesValuesSize = product.Attributes[0].Values | Size -%}
        {% if productAttributesValuesSize == 1 -%}
            {% assign directAddToCart = true -%}
        {% endif -%}
    {% endif %}
{% endif -%}

<div class="ai-recommendations-item swiper-slide">
    <div class="ai-recommendations-item__wrapper">
        <div class="ai-recommendations-item__image-wrapper">
            {% if product.Image -%}
                {{product | Img: 'large' }}
            {% else %}
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                </svg>
            {% endif -%}
            {% if flags != empty -%}
                <div class="ai-recommendations-item__flags">
                    {% for flag in product.Flags limit: 2 %}
                        <div title="{{ flag.Text }}" class="ai-recommendations-item__flag {{ flag.Type }}">
                            {% if flag.Type == "Reward" -%}
                                {{ translations.PointsProduct }}
                            {% else -%}
                                {{ flag.Text}}
                            {% endif -%}
                        </div>
                    {% endfor %}
                </div>
            {% endif -%}
        </div>
        <div class="ai-recommendations-item__section">
            <a href="{{ page.BaseHref }}{{ product.Url }}?ai-recommendation=true" aria-label="product-link">
                <h3 class="ai-recommendations-item__name">{{ product.NameNoHtml }}</h3>
            </a>
        </div>
        <div class="ai-recommendations-item__section">
            <div class="ai-recommendations-item__price-wrapper">
                <span class="ai-recommendations-item__price bold-price">
                        {{ product.Price | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                </span>

                {% if product.PreviousPrice and product.PreviousPrice > product.Price  -%}
                    <span class="ai-recommendations-item__price old-price" {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %} title="{{translations.SuggestedRetailPrice}}" {% endif -%}>
                        {{ product.PreviousPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} 
                        {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                    </span>
                {% elseif product.RegularPrice and product.RegularPrice > product.Price  and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                    <span class="ai-recommendations-item__price old-price">
                        {{ product.RegularPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                    </span>
                {% endif -%}

                {% assign productPrice = product.Price %}
                {% assign isSubtotalPrices = customer.Cart.SubtotalPrices -%}
                {% if productPrice > 0 -%}
                    <span class="ai-recommendations-item__price">
                        {% if isSubtotalPrices -%}
                            {{ translations.Netto | Downcase }}
                        {% else -%}
                            {{ translations.Brutto | Downcase }}
                        {% endif -%}
                    </span>
                {% endif -%}
            </div>
            {% if product.DepositValue > 0 -%}
                <span class="ai-recommendations-item__deposit-price">
                    + {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
                </span>
            {% endif -%}
            {% if product.PreviousPrice != null and product.PreviousPrice > product.Price and settings.lowestProductPrice == 'yes' -%}
                <div class="ai-recommendations-item__omnibus">
                    <span>{{ product.MinPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
                    <span>
                        {% if customer.Cart.SubtotalPrices -%}
                            {{ translations.Netto | Downcase }}
                        {% else -%}
                            {{ translations.Brutto | Downcase }}
                        {% endif -%}
                    </span>
                    <span> - {{translations.Price_Omnibus}}</span>
                </div>
            {% else -%}
                <div class="ai-recommendations-item__omnibus-placeholder"></div>
            {% endif -%}
        </div>
        <div class="ai-recommendations-item__section btn-section {% if directAddToCart -%} form-js add-to-cart-js {% endif -%}">
            {% if product.Price == null or product.AskForPrice -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{product.Url}}?open=askForPrice" title="{{ translations.AskForPrice }}">
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
                    </svg>
                </a>
            {% else -%}
                {% if directAddToCart -%}
                    <input type="hidden" name="__action" value="Cart/Add" >
                    <input type="hidden" name="productId" value="{{ product.Id }}" >
                    <input name="quantity" type="hidden" value="1">
                {% endif -%}
                <button class="secondary-action-button ai-recommendations-item__primary-btn {% if directAddToCart -%} parent-container-reload-js add-to-cart-button-js add-to-cart-update-client-area-js parent-container-reload-js {% else -%} open-add-to-cart-popup-js choose-variant-js {% endif -%}" {% if directAddToCart != true -%} data-url="{{ page.BaseHref }}{{ product.Url }}" {% endif -%} title="{{ translations.AddToCart }}">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{settings.cartIconStyle}}-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            {% endif -%}
        </div>
    </div>
</div>
`